import styled, { GlobalStyles } from '@mui/styled-engine-sc';

export * from '@mui/styled-engine-sc';
export const internal_serializeStyles = (styles) => styles;
export { GlobalStyles };

export default styled;
